import React, { Component } from 'react';
import styles from '../Dynamics/index.module.scss';
import axios from "@/util/axios";
import { api } from "@/routes/api";
import { Link } from 'react-router-dom';
import { default_page_size } from '@/config/base';
import { connect } from 'react-redux';
import { changeLoading } from '@/redux/base.redux';

@connect(
  null,
  { changeLoading }
)
class TeaAppreciation extends Component {
  state = {
    page: 1,
    limit: default_page_size[0],
    list: [],
    ambulance: '',
    count: 0,
    menuSelectIndex: 3
  }
  componentDidMount = () => {
    this.getDynamicsList();
  }
  getDynamicsList = async (page = this.state.page, limit = this.state.limit, otherParam = { type: 3 }) => {
    this.props.changeLoading(true);
    const res = await axios.post(api.getNewsList, { page, limit, ...otherParam });
    const { data, ambulance } = res;
    const { count, data: list } = data;
    this.setState({ count, list, ambulance });
    setTimeout(() => this.props.changeLoading(false), 500);
  }
  handleChangeNewsMenu = (menuSelectIndex) => {
    this.setState({ menuSelectIndex });
    this.getDynamicsList(1, this.state.limit, { type: menuSelectIndex });
  }
  render() {
    const { list, ambulance, menuSelectIndex } = this.state;
    return (
      <div>
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.dynamic_container}>
          <div className={styles.menu_container}>
            <ul>
              <li className={`${styles.menu_item} ${menuSelectIndex === 3 ? styles.active : ''}`} onClick={() => this.handleChangeNewsMenu(3)}>四季茗茶</li>
              <li className={`${styles.menu_item} ${menuSelectIndex === 4 ? styles.active : ''}`} onClick={() => this.handleChangeNewsMenu(4)}>艺述茶香</li>
            </ul>
          </div>
          <div className={styles.content_container}>
            <ul>
              {
                list.map(item => (
                  <Link key={item.id} to={`/tea_appreciation/detail/${item.id}`}>
                    <li>
                      <div className={styles.img_container}>
                        <img src={ambulance + item.photo} alt="" />
                      </div>
                      <div className={styles.content}>
                        <div className={styles.title_container}>
                          <div className={styles.title}>{item.title}</div>
                          <div className={styles.time}>{item.create_time}</div>
                          <div className={styles.clearfix}></div>
                        </div>
                        <div className={styles.desc}>{item.intro}</div>
                      </div>
                    </li>
                  </Link>
                ))
              }
            </ul>
          </div>
          <div className={styles.clearfix}></div>
        </div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TeaAppreciation;
